/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum BackofficeGroupGoUserPermission {
    CanWriteCustomers = 'CanWriteCustomers',
    CanWriteContracts = 'CanWriteContracts',
    CanWriteClaims = 'CanWriteClaims'
  }

    export const BackofficeGroupGoUserPermissionTranslocoMap: Record<BackofficeGroupGoUserPermission, string> = {
    [BackofficeGroupGoUserPermission.CanWriteCustomers]: 'backofficeGroupGoUserPermission.canWriteCustomers',
    [BackofficeGroupGoUserPermission.CanWriteContracts]: 'backofficeGroupGoUserPermission.canWriteContracts',
    [BackofficeGroupGoUserPermission.CanWriteClaims]: 'backofficeGroupGoUserPermission.canWriteClaims',
    };

    export const BackofficeGroupGoUserPermissionOptions = [
  { value: BackofficeGroupGoUserPermission.CanWriteCustomers, labelKey: 'backofficeGroupGoUserPermission.canWriteCustomers' },
  { value: BackofficeGroupGoUserPermission.CanWriteContracts, labelKey: 'backofficeGroupGoUserPermission.canWriteContracts' },
  { value: BackofficeGroupGoUserPermission.CanWriteClaims, labelKey: 'backofficeGroupGoUserPermission.canWriteClaims' },
    ];

